<template>
    <div class="custom-select w-100"  ref="customSelect">
      <div @click="toggleDropdown" class="select-header" :disabled="disable">
        <span v-if="selectedOption" class="py-1 px-2"  
            :style="{ backgroundColor: selectedOption ? selectedOption.color : '#f5f5f5', 
                      color: selectedOption.color ? '#fff' : '#606266',
                      fontSize : selectedOption.color ? '10px' : '13px' 
            }"
            style="border-radius: 4px;font-size: 10px;">
          {{ selectedOption.name }}
        </span>
        <span v-else ref="placeHolder" :style="{
          display: isOpen ? 'none' : 'block',
          fontSize: '13px',
          fontWeight: 400,
          color: '#b9bec6f3'
        }">
          {{ placeholder }}
        </span>
        <input v-if="isOpen" v-model="searchText" ref="filterInput" class="filter-input" />
        <i v-if="selectedOption" class="el-icon-close" style="color: #C0C4CC;" @click.stop="removeSelect"></i>
        <i v-else class="arrow" :class="{ 'open': isOpen }"></i>
      </div>
      <ul :class="{ 'select-dropdown w-100 open': isOpen, 'select-dropdown w-100': !isOpen }">
        <li 
          v-for="(option, index) in filterOptions"
          :key="index" 
          @click="selectOption(option)" 
          :class="{ 'selected': option.id === selectedValue,
              'color' : option.color
           }"
        >
          <span class="p-2" :style="{ backgroundColor: option.color ? option.color : '#909399' }">{{ option.name }}</span>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      options: {
        type: Array,
        required: true,
      },
      value: {
        required: false,
      },
      placeholder: {
        type: String,
        default: "Select an option",
      },
      disable : {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        isOpen: false,
        selectedValue: this.value,
        searchText: '',
      };
    },
    computed: {
      filterOptions() {
        if (!this.searchText) return this.options;
        return this.options.filter(
          (option) => option.name.trim().toLowerCase().includes(this.searchText.trim().toLowerCase())
        );
      },
      selectedOption() {
        return this.options.find(option => option.id === this.value);
      },
    },
    watch: {
      value(newValue) {
        this.selectedValue = newValue;
      },
    },
    methods: {
      toggleDropdown() {
        if (this.disable) return;
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
          this.$nextTick(() => {
            this.$refs?.filterInput?.focus();
          });
        }
      },
      selectOption(option) {
        if (this.disable) return;
        this.selectedValue = option.id;
        this.$emit('input', this.selectedValue);
        this.isOpen = false;
        this.searchText = '';
      },
      handleClickOutside(event) {
        if (!this.$refs.customSelect.contains(event.target)) {
          this.isOpen = false;
        }
      },
      removeSelect() {
        if (this.disable) return;
        this.selectedValue = ''; 
        this.$emit('input', this.selectedValue); 
        this.isOpen = true;
      }
    },
    mounted() {
      document.addEventListener('click', this.handleClickOutside);
      this.selectOption(this.options[0])
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handleClickOutside);
    },
  };
  </script>
  
  <style scoped>
  .custom-select {
    position: relative;
    cursor: pointer;
    height: 32px;
  }
  .select-header {
    height: 32px;
    border: 1px solid #DCDFE6;
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .select-header[disabled] {
    background: #f5f5f5;
    cursor: not-allowed;
    color: #c0c4cc;
  }
  .select-dropdown {
    position: absolute;
    width: 100%;
    background: #fff;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    margin-top: 4px;
    z-index: 10;
    list-style: none;
    padding: 0;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    transition: max-height 0.2s ease-in-out, opacity 0.2s ease-in-out;
  }
  
  .select-dropdown.open {
    overflow-y: scroll;
    max-height: 150px;
    opacity: 1;
  }
  .select-dropdown li {
    padding: 12px 20px;
  }
  .select-dropdown li span {
    border-radius: 4px;
    color: #FFFFFF;
    font-weight: 600;
    font-size: 12px;
  }
  .select-dropdown li:hover {
    background: #F5F7FA;
  }
  .select-dropdown li.selected {
    background: #e6f7ff;
  }
  .select-header span{
    font-size: 13px;
    padding: 0 0 0 8px;
    font-weight: 400;
    color: #b9bec6f3;
  }
  .arrow {
    position: relative;
    top: -2px;
    right: 4px;
    border: solid #DCDFE6;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
    transition: transform 0.2s;
  }
  .arrow.open {
    top: 2px;
    transform: rotate(-135deg);
  }

  .filter-input {
    border: none;
    outline: none;
    font-size: 13px;
    background: transparent;
    padding: 0 4px;
    min-width: 60px;
    flex: 1;
  }
  </style>
  